import { Store } from "lucide-react";
import { mediaUrl } from "../lib/api";
import { useSiteContent } from "../lib/siteContent";

export default function BrandLogo({ size = "h-8 w-8", iconSize = "h-4 w-4", light = false }) {
  const { logo_image_id } = useSiteContent();
  if (logo_image_id) {
    return <img src={mediaUrl(logo_image_id)} alt="MatteusMx logo" className={`${size} rounded-lg object-cover`} data-testid="brand-logo-img" />;
  }
  return (
    <div className={`${size} rounded-lg ${light ? "bg-white/10" : "bg-slate-900"} flex items-center justify-center`} data-testid="brand-logo-default">
      <Store className={`${iconSize} text-white`} />
    </div>
  );
}
